/**
 * @generated SignedSource<<684e9c3e7d8ba574e8dfe70d5ecefd45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemType = "EVENT" | "REALM" | "SERIES" | "%future added value";
export type TextAssetType = "CAPTION" | "SLIDE_TEXT" | "%future added value";
export type Filters = {
  end?: string | null | undefined;
  itemType?: ItemType | null | undefined;
  start?: string | null | undefined;
};
export type SearchQuery$variables = {
  filters: Filters;
  q: string;
};
export type SearchQuery$data = {
  readonly search: {
    readonly __typename: "EmptyQuery";
    readonly dummy: boolean | null | undefined;
  } | {
    readonly __typename: "SearchResults";
    readonly duration: number;
    readonly items: ReadonlyArray<{
      readonly __typename: "SearchEvent";
      readonly audioOnly: boolean;
      readonly created: string;
      readonly creators: ReadonlyArray<string>;
      readonly description: string | null | undefined;
      readonly duration: number;
      readonly endTime: string | null | undefined;
      readonly hostRealms: ReadonlyArray<{
        readonly ancestorNames: ReadonlyArray<string | null | undefined>;
        readonly name: string | null | undefined;
        readonly path: string;
      }>;
      readonly id: string;
      readonly isLive: boolean;
      readonly matches: {
        readonly creators: ReadonlyArray<{
          readonly index: number;
          readonly span: string;
        }>;
        readonly description: ReadonlyArray<string>;
        readonly seriesTitle: ReadonlyArray<string>;
        readonly title: ReadonlyArray<string>;
      };
      readonly seriesId: string | null | undefined;
      readonly seriesTitle: string | null | undefined;
      readonly startTime: string | null | undefined;
      readonly textMatches: ReadonlyArray<{
        readonly duration: number;
        readonly highlights: ReadonlyArray<string>;
        readonly start: number;
        readonly text: string | null | undefined;
        readonly ty: TextAssetType;
      }>;
      readonly thumbnail: string | null | undefined;
      readonly title: string;
    } | {
      readonly __typename: "SearchRealm";
      readonly ancestorNames: ReadonlyArray<string | null | undefined>;
      readonly id: string;
      readonly matches: {
        readonly name: ReadonlyArray<string>;
      };
      readonly name: string | null | undefined;
      readonly path: string;
    } | {
      readonly __typename: "SearchSeries";
      readonly description: string | null | undefined;
      readonly hostRealms: ReadonlyArray<{
        readonly ancestorNames: ReadonlyArray<string | null | undefined>;
        readonly name: string | null | undefined;
        readonly path: string;
      }>;
      readonly id: string;
      readonly matches: {
        readonly description: ReadonlyArray<string>;
        readonly title: ReadonlyArray<string>;
      };
      readonly thumbnailStack: {
        readonly thumbnails: ReadonlyArray<{
          readonly audioOnly: boolean;
          readonly live: boolean;
          readonly url: string | null | undefined;
        }>;
      };
      readonly title: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
    readonly totalHits: number;
  } | {
    readonly __typename: "SearchUnavailable";
    readonly dummy: boolean | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentSpreads": FragmentRefs<"UserData">;
};
export type SearchQuery = {
  response: SearchQuery$data;
  variables: SearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v2 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "q"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dummy",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "EmptyQuery",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "SearchUnavailable",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creators",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesTitle",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLive",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audioOnly",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ancestorNames",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "SearchRealm",
  "kind": "LinkedField",
  "name": "hostRealms",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "TextMatch",
  "kind": "LinkedField",
  "name": "textMatches",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ty",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highlights",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "SearchEventMatches",
  "kind": "LinkedField",
  "name": "matches",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ArrayMatch",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "index",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "span",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "SeriesThumbnailStack",
  "kind": "LinkedField",
  "name": "thumbnailStack",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ThumbnailInfo",
      "kind": "LinkedField",
      "name": "thumbnails",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "live",
          "storageKey": null
        },
        (v16/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "SearchSeriesMatches",
  "kind": "LinkedField",
  "name": "matches",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "SearchRealmMatches",
  "kind": "LinkedField",
  "name": "matches",
  "plural": false,
  "selections": [
    (v21/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalHits",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "SearchRealm",
  "kind": "LinkedField",
  "name": "hostRealms",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserData"
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ],
                    "type": "SearchEvent",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v26/*: any*/),
                      (v23/*: any*/),
                      (v27/*: any*/)
                    ],
                    "type": "SearchSeries",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v21/*: any*/),
                      (v20/*: any*/),
                      (v22/*: any*/),
                      (v28/*: any*/)
                    ],
                    "type": "SearchRealm",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v29/*: any*/),
              (v11/*: any*/)
            ],
            "type": "SearchResults",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SearchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRealmHandle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseStudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseEditor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateUserRealm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateSeries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTobiraAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canFindUnlisted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRole",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v30/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ],
                    "type": "SearchEvent",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v26/*: any*/),
                      (v30/*: any*/),
                      (v27/*: any*/)
                    ],
                    "type": "SearchSeries",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v21/*: any*/),
                      (v20/*: any*/),
                      (v22/*: any*/),
                      (v28/*: any*/)
                    ],
                    "type": "SearchRealm",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v29/*: any*/),
              (v11/*: any*/)
            ],
            "type": "SearchResults",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f5085e071c13953a931e983a69c85e19",
    "id": null,
    "metadata": {},
    "name": "SearchQuery",
    "operationKind": "query",
    "text": "query SearchQuery(\n  $q: String!\n  $filters: Filters!\n) {\n  ...UserData\n  search(query: $q, filters: $filters) {\n    __typename\n    ... on EmptyQuery {\n      dummy\n    }\n    ... on SearchUnavailable {\n      dummy\n    }\n    ... on SearchResults {\n      items {\n        __typename\n        ... on SearchEvent {\n          id\n          title\n          description\n          thumbnail\n          duration\n          creators\n          seriesTitle\n          seriesId\n          isLive\n          audioOnly\n          startTime\n          endTime\n          created\n          hostRealms {\n            path\n            name\n            ancestorNames\n            id\n          }\n          textMatches {\n            start\n            duration\n            text\n            ty\n            highlights\n          }\n          matches {\n            title\n            description\n            seriesTitle\n            creators {\n              index\n              span\n            }\n          }\n        }\n        ... on SearchSeries {\n          id\n          title\n          description\n          thumbnailStack {\n            thumbnails {\n              url\n              live\n              audioOnly\n            }\n          }\n          hostRealms {\n            path\n            name\n            ancestorNames\n            id\n          }\n          matches {\n            title\n            description\n          }\n        }\n        ... on SearchRealm {\n          id\n          name\n          path\n          ancestorNames\n          matches {\n            name\n          }\n        }\n        id\n      }\n      totalHits\n      duration\n    }\n  }\n}\n\nfragment UserData on Query {\n  currentUser {\n    username\n    displayName\n    userRealmHandle\n    canUpload\n    canUseStudio\n    canUseEditor\n    canCreateUserRealm\n    canCreateSeries\n    isTobiraAdmin\n    canFindUnlisted\n    roles\n    userRole\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bfe4c600abe0c7cd5ae3ec7666b5e90";

export default node;
